module.exports = __webpack_public_path__ + "img/inmarsat-iridium.185d5d3c.png";